"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _IconButton.default;
  }
});

var _IconButton = _interopRequireDefault(require("./IconButton"));


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/IconButton/index.js
// module id = 63
// module chunks = 35783957827783 70144966829960 114276838955818